import React from 'react';
import { inject, observer } from 'mobx-react';
import AppLayout from 'layouts/AppLayout';
import Wrapper from 'components/Wrapper';
import ContentWrapper from 'components/ContentWrapper';
import Button from 'components/Button';
import cn from 'classnames';
import LevelFunctionalityModal from 'components/LevelFunctionalityModal';
import moment from 'moment';
import UserLevelProgressBar from '../../components/UserLevelProgressBar';
import MainTopWrapper from '../../components/MainTopWrapper';
import styles from './styles.module.scss';
import planetSimpleSilver from '../../assets/icons/profile/Silver/planetSimpleSilver.png';
import planetSimpleGold from '../../assets/icons/profile/Gold/planetSimpleGold.png';
import planetSimplePlatinum from '../../assets/icons/profile/Platinum/planetSimplePlatinum.png';
import infoSign from '../../assets/icons/profile/info-sign.svg';

import { getLevelAdvantages } from '../../helpers/advantages.js';

const getSimplePlanet = (level) => {
    switch (level) {
    case 'Silver':
        return planetSimpleSilver;
    case 'Gold':
        return planetSimpleGold;
    case 'Platinum':
        return planetSimplePlatinum;
    default:
        return '';
    }
};

class ProfilePage extends React.Component {
    constructor(props) {
        super(props);
        this.store = props.store;
        this.state = {
            title: 'Личный кабинет продавца',
            selectedImage: null,
            isShowLevelFunctionalityModal: false,
            loadingUpdateProfileImage: false,
        };
    }

    componentDidMount() {
        document.title = this.state.title;
    }

    render() {
        const currentPeriodLevel = this.store.profile.user.level && this.store.profile.user.level.currentPeriod.level;
        const { profileImageUrl } = this.store.profile;
        return (
            <AppLayout
                userName={this.store.profile.getUserNameField('navbar')}
                companyCode={this.store.app.companyCode}
            >
                <Wrapper>
                    <MainTopWrapper
                        profile={this.store.profile}
                    />
                    {this.state.isShowLevelFunctionalityModal && (
                        <LevelFunctionalityModal
                            handleClose={() => this.setState({ isShowLevelFunctionalityModal: false })}
                        />
                    )}
                    <ContentWrapper>
                        <div className={styles.ProfilePageTitle}>
                            {'Мой профиль'}
                        </div>
                        <div className={styles.ProfilePageCard}>
                            <div className={styles.ProfilePageCardHeader}>
                                <div className={styles.ProfilePhotoWrapper}>
                                    <img
                                        className={styles.ProfilePhoto}
                                        src={profileImageUrl || 'images/profile/user.jpg'}
                                        alt={'Фото профиля'}
                                    />
                                </div>
                                <div className={styles.ProfileInfoWrapper}>
                                    <div className={styles.ProfileInfoName}>
                                        {`${this.store.profile.getUserNameField('name')} ${this.store.profile.getUserNameField('surname')}`}
                                    </div>
                                    <div className={styles.ProfileInfoDetails}>
                                        <div
                                            className={cn(styles.ProfileInfoItem, styles.ProfileInfoItem__ImageWrapper)}>
                                            <div className={cn(styles.ProfileInfoItem__Image,
                                                styles[`ProfileInfoItem__Image_${currentPeriodLevel}`])}></div>
                                            <div className={styles.ProfileInfoItem__Title}>
                                                {`Уровень: ${this.store.profile.getUserLevelPlanet('levelPlanet')}`}
                                            </div>
                                        </div>
                                        <div
                                            className={cn(styles.ProfileInfoItem, styles.ProfileInfoItem__Balance)}>
                                            {`Уралкоинов: ${this.store.profile.user.balance && this.store.profile.user.balance.total.toLocaleString()}`}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.ProfilePageCardLevel}>
                                <img
                                    src={getSimplePlanet(currentPeriodLevel)}
                                    alt="Планета уровня"
                                    className={styles.ProfilePageCardLevel__Planet}/>
                                <div className={styles.ProfilePageCardLevel__LevelInfo}>
                                    <div className={cn(styles.ProfilePageCardLevel__LevelName,
                                        styles[`ProfilePageCardLevel__LevelName_${currentPeriodLevel}`])}>
                                        <div>
                                            {this.store.profile.getUserLevelPlanet('levelPlanet')}
                                        </div>
                                        <Button
                                            className={styles.ProfilePageCardLevel__Functionality}
                                            onClick={() => this.setState({ isShowLevelFunctionalityModal: true })}
                                        >
                                            <img
                                                src={infoSign}
                                                alt={'Функционал уровней'}/>
                                        </Button>
                                    </div>
                                    <div className={styles.ProfilePageCardLevel__DateActiveUntil}>
                                        {`Бонусы действуют до ${this.store.profile.user.level && moment(this.store.profile.user.level.currentPeriod.validTo).format('DD.MM.YY')}`}
                                    </div>
                                </div>
                            </div>
                            <div className={styles.ProfilePageCardCapabilities}>
                                <div className={styles.CapabilitiesTitle}>
                                    {'Вам доступны'}
                                </div>
                                <div className={styles.CapabilitiesItemWrapper}>
                                    {getLevelAdvantages(currentPeriodLevel).map((advantageItem, index) => <div
                                        key={index}
                                        className={styles.CapabilitiesItem}>
                                        {advantageItem}
                                    </div>)
                                    }
                                </div>
                            </div>
                            <div className={styles.ProfilePageCardNextQuarterLevel}>
                                <div className={styles.ProfilePageCardNextQuarterLevel__Title}>
                                    {'Выполнение условий уровней на следующий квартал'}
                                </div>
                                <div className={styles.ProfilePageCardNextQuarterLevel__Dates}>
                                    {`с ${this.store.profile.user.level && moment(this.store.profile.user.level.nextPeriod.validFrom).format('DD.MM.YY')}г по 
                                        ${this.store.profile.user.level && moment(this.store.profile.user.level.nextPeriod.validTo).format('DD.MM.YY')}г`}
                                </div>
                            </div>
                            <div className={styles.ProfilePageCardLevelInfo}>
                                <UserLevelProgressBar/>
                            </div>
                        </div>
                    </ContentWrapper>
                </Wrapper>
            </AppLayout>
        );
    }
}

export default inject('store')(observer(ProfilePage));
